import { Button, Chip, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import StarIcon from '@mui/icons-material/Star';
import StarBorderOutlinedIcon from '@mui/icons-material/StarBorderOutlined';
import styled from '@emotion/styled';

export const PopupTitle = styled(DialogTitle)(({ theme }) => `
padding: 10px 16px;
text-align: center;
font-size: 16px;
@media (min-width: 600px){
  padding: 16px 24px;
  font-size: 18px;
  }
`);

export const DescriptionContent = styled('div')(() => `
max-width: 370px;
padding: 10px 16px;
text-align:center;
font-size: 14px;
@media (min-width: 600px){
    font-size: 16px;
    padding: 16px 24px;
  }
`);

export const ChipStyled = styled(Chip)(() => `
display: flex;
justify-content: center;
align-items:center;
font-weight: 500;
flex-grow: 1;
width: 40%;
// @media (min-width: 600px) {
//   width: auto;
// }
`);

export const WrapperStars = styled('span')(() => `
display: flex;
justify-content: center;
align-items:center;
font-weight: 500;
`);

export const IconStar = styled(StarIcon)(() => `
width: 16px;
height: 16px;
`);

export const IconStarOutline = styled(StarBorderOutlinedIcon)(() => `
width: 16px;
height: 16px;
`);


export const CapitalizeWord = styled('span')(({ theme }) => `
text-transform: capitalize;
`);

export const ContentStyled = styled(DialogContent)(() => `
display: flex;
flex-wrap: wrap;
justify-content: center;
align-items: center;
gap: 10px;
padding: 10px 16px;
@media (min-width: 600px){
    padding: 16px 24px;
  }
`);



export const WrapperActions = styled(DialogActions)`
display: flex;
flex-direction: column;
justify-content: center;
align-items: center;
gap: 20px;
padding: 10px 16px;
min-width: 100%;
@media (min-width: 600px){
    padding: 16px 24px;
  }
`;

export const ButtonStyled = styled(Button)(({ theme, color }) => `
width: 100%;
&:not(:first-of-type) {
    margin-left: 0;
}
&:first-of-type {
    margin-left: 0;
}
`);



